import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var groupListRes;
export const groupListTodo = createAsyncThunk('groupList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_group_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "status": data.status,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return groupListRes = res.data
    } catch (error) {
        return groupListRes = error.response.data
    }
})


const groupListSlice = createSlice({
    name: 'groupList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(groupListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('groupList', state.data)
            }
        });
        builder.addCase(groupListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default groupListSlice.reducer; 